const steps = [
  { icon: 'ri-focus-3-line', label: 'Lead Captured', color: 'from-teal-500 to-teal-400', desc: 'Website form / WhatsApp / Source' },
  { icon: 'ri-whatsapp-line', label: 'AI Engages', color: 'from-emerald-500 to-teal-500', desc: 'Chatbot qualifies & converses' },
  { icon: 'ri-map-2-line', label: 'Itinerary Built', color: 'from-teal-500 to-emerald-400', desc: 'AI-assisted day-by-day plan' },
  { icon: 'ri-file-paper-2-line', label: 'Quote Sent', color: 'from-emerald-500 to-green-500', desc: 'PDF via WhatsApp or email' },
  { icon: 'ri-checkbox-circle-line', label: 'Customer Accepts', color: 'from-green-500 to-teal-500', desc: 'One-click acceptance link' },
  { icon: 'ri-bank-card-line', label: 'Payment Link', color: 'from-teal-500 to-emerald-500', desc: 'Agent sends custom link' },
  { icon: 'ri-send-plane-line', label: 'Confirmation Sent', color: 'from-emerald-500 to-teal-400', desc: 'WhatsApp + email delivered' },
  { icon: 'ri-chat-follow-up-line', label: 'Follow-up & CRM', color: 'from-teal-500 to-emerald-500', desc: 'Feedback, changes, history' },
];

export default function JourneyFlow() {
  return (
    <section className="py-20 px-6 bg-gray-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs font-medium uppercase tracking-widest text-teal-400 mb-3">End-to-End Automation</p>
          <h2 className="text-3xl md:text-4xl font-semibold text-white leading-tight tracking-tight">
            One Platform. The Entire Customer Journey.
          </h2>
          <p className="text-gray-400 mt-4 max-w-xl mx-auto text-sm leading-relaxed">
            TreWaz handles every step automatically — your team just steps in where human touch matters most.
          </p>
        </div>

        {/* Flow diagram */}
        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-8 left-0 right-0 h-[2px] bg-gradient-to-r from-teal-500/20 via-teal-500/60 to-teal-500/20 z-0" style={{ top: '2.25rem' }} />

          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4">
            {steps.map((step, i) => (
              <div key={step.label} className="relative flex flex-col items-center text-center z-10">
                {/* Step number badge */}
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-gray-800 rounded-full flex items-center justify-center z-20">
                  <span className="text-[9px] font-semibold text-teal-400">{i + 1}</span>
                </div>
                {/* Icon circle */}
                <div className={`w-[46px] h-[46px] rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center mb-3 relative z-10`}>
                  <i className={`${step.icon} text-white text-lg`} />
                </div>
                <p className="text-xs font-semibold text-white mb-1 leading-tight">{step.label}</p>
                <p className="text-[11px] text-gray-500 leading-snug">{step.desc}</p>

                {/* Arrow between steps (mobile hidden) */}
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-[22px] right-[-12px] z-20">
                    <i className="ri-arrow-right-s-line text-teal-500/50 text-sm" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <p className="text-center text-xs text-gray-600 mt-10">
          <i className="ri-information-line mr-1" />
          TreWaz is an AI assistance & automation tool — it does not include an automatic booking engine or direct supplier database integration.
        </p>
      </div>
    </section>
  );
}
